var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeutralSentiment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,.75A11.25,11.25,0,1,0,23.25,12,11.263,11.263,0,0,0,12,.75Z",
    fill: "#f7c377",
    opacity: 0.173
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9,16.25a.75.75,0,0,1-.75.75H6.75A.75.75,0,0,1,6,16.25V9.75A.75.75,0,0,1,6.75,9h1.5A.75.75,0,0,1,9,9.75Z",
    fill: "#f7c377"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.99,11.37l-.7,4.48a2.005,2.005,0,0,1-1.97,1.65H15.29c-4.24,0-6.04-1.41-6.04-1.41L9,15.89V9.72s-3.957,3.794.25-.13,5.1-.57,5.1-.57h2.67a2,2,0,0,1,1.97,2.35Z",
    fill: "#f7c377"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12,24A12,12,0,1,1,24,12,12.013,12.013,0,0,1,12,24ZM12,1.5A10.5,10.5,0,1,0,22.5,12,10.512,10.512,0,0,0,12,1.5Z",
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25,18H6.75A1.752,1.752,0,0,1,5,16.25V9.75A1.752,1.752,0,0,1,6.75,8h1.5A1.752,1.752,0,0,1,10,9.75v6.5A1.752,1.752,0,0,1,8.25,18ZM6.75,9.5a.25.25,0,0,0-.25.25v6.5a.25.25,0,0,0,.25.25h1.5a.25.25,0,0,0,.25-.25V9.75a.25.25,0,0,0-.25-.25Z",
    fill: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.57,18H15.54c-4.448,0-6.421-1.506-6.5-1.57l-.256-.2a.75.75,0,0,1,.936-1.172l.25.2c.005,0,1.7,1.246,5.572,1.246h1.03A1.251,1.251,0,0,0,17.8,15.468l.7-3.978a1.25,1.25,0,0,0-1.232-1.47H13.85a.75.75,0,0,1-.626-1.163,3.765,3.765,0,0,0,.437-1.848c0-1.141-.445-1.51-.66-1.51h-.012a3.284,3.284,0,0,0-.089.952c0,2.391-2.921,3.984-3.046,4.051l-.257.134A.75.75,0,1,1,8.9,9.305l.25-.13C9.772,8.84,11.4,7.689,11.4,6.45c0-.8,0-2.45,1.6-2.45,1.041,0,2.16.942,2.16,3.01a5.764,5.764,0,0,1-.2,1.51H17.27a2.75,2.75,0,0,1,2.709,3.233l-.7,3.977A2.751,2.751,0,0,1,16.57,18Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralSentiment);
export default __webpack_public_path__ + "static/media/neutral-sentiment.cd98fdc18829e74af7d1244ff3e7de1e.svg";
export { ForwardRef as ReactComponent };